import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../lib/supabase';

type AuthGateProps = {
  children: React.ReactNode;
};

export const AuthGate: React.FC<AuthGateProps> = ({ children }) => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      const { data } = await supabase.auth.getUser();
      if (!active) return;
      if (!data.user) {
        navigate('/login');
      } else {
        setChecking(false);
      }
    })();
    return () => { active = false; };
  }, [navigate]);

  if (checking) return null;
  return <>{children}</>;
};

export default AuthGate;



